import { GeneralModel } from "./general.model";

export class WeightGroup extends GeneralModel {
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/models/weightGroup.model.ts